// 新增数码品类接口 笔记本电脑/耳机
import { feHost, feStoreHost, zzHost } from 'conf/hosts.conf'
export default {
  // 前端阿波罗配置前缀
  getFeApolloInfo: feHost,
  getFeStoreApolloInfo: feStoreHost,
  getGoldTrendSubscribeText: feStoreHost,

  // 鹰眼 AB 测通用接口
  getCommonABTest: `${zzHost}/zzopen/zzbmlogic/getSceneGroupName`,
  // 寄卖服务的 AB 测接口
  getCommonABTestConsignment: `${zzHost}/zzopen/c2b_consignment/sceneTest`,
  // 鹰眼批量 AB 测通用接口
  getMultiABTest: `${zzHost}/zzopen/zzbmlogic/multiGetSceneGroupName`,
  // 获取地址信息
  getLocalCity: `${zzHost}/zzopen/zzbmlogic/getLocalCity`,

  // 卖场相关接口 -------- start--
  // 卖场列表页配置基本信息
  getAuctionConfig: `${zzHost}/zzopen/zzbmmarketlogic/getAuctionConfig`,
  // 卖场列表
  getAuctionList: `${zzHost}/zzopen/zzbmmarketlogic/getAuctionList`, //  卖场列表, 以下接口调用一样是为了和api老接口一一对应
  getMyAuctionList: `${zzHost}/zzopen/zzbmmarketlogic/getAuctionList`, // 本场参拍
  getMyDelayAuctionList: `${zzHost}/zzopen/zzbmmarketlogic/getAuctionList`, // 延时参拍
  // 关注接口
  updateAttention: `${zzHost}/zzopen/zzbmmarketlogic/focusAuctionInfo`,
  // 抬一手的价格列表
  getAuctionOfferPriceList: `${zzHost}/zzopen/zzbmmarketlogic/getAuctionOfferPriceList`,
  auctionSubscribe: `${zzHost}/zzopen/ypdeal/auctionBuyerSubscribe`,
  auctionCancelSubscribe: `${zzHost}/zzopen/ypdeal/auctionBuyerSubscribeCancel`,
  getAuctionItemDetail: `${zzHost}/zzopen/ypdeal/buyerActivityDetailStat`,
  getDelaySessionTime: `${zzHost}/zzopen/zzbmmarketlogic/getDelayLeftTime`,
  // 获取笔记本盲拍卖场的明拍入口卡片
  getNoteBookCard: `${zzHost}/zzopen/zzbmmarketlogic/getNoteBookCard`,

  // 历史成交页 --------- start ------
  // 筛选项 品类，成色，版本, 排序(与竞拍卖场列表页筛选使用同一个接口)
  getAllQueryParams: `${zzHost}/zzopen/zzbmmarketlogic/getMarketQueryCondition`,
  // 筛选项 容量(与竞拍卖场列表页筛选使用同一个接口)
  getCapacityParams: `${zzHost}/zzopen/zzbmmarketlogic/getCapacityParams`,
  // 获取历史成交列表
  getHistoryList: `${zzHost}/zzopen/zzbmmarketlogic/getHistoryList`,
  // 获取历史成交列表-无筛选项
  getNewHistoryList: `${zzHost}/zzopen/zzbmmarketlogic/getNewHistoryList`,
  // D方案获取历史成交列表
  getHistoryDealList: `${zzHost}/zzopen/zzbmmarketlogic/getHistoryDealList`,
  // 获取历史成交页机型默认容量、版本参数
  getHistoryDefaultParams: `${zzHost}/zzopen/zzbmmarketlogic/getHistoryDefaultParams`,
  // 获取zz服务次数
  getServerCount: `${zzHost}/zz/transfer/refreshzzplusservercount`,

  // 竞拍卖场商品详情页  ------- start -----
  // 获取成色示例(历史成交页和卖场详情页共用)
  getFineness: `${zzHost}/zzopen/zzbmmarketlogic/getOldLevelExplain`,
  // 竞拍详情页基本数据
  getAuctionDetail: `${zzHost}/zzopen/zzbmmarketlogic/getAuctionDetail`,
  // 判断调用新竞拍详情接口还是老竞拍详情接口
  getIsNewSystem: `${zzHost}/zzopen/zzbmmarketlogic/isNewSystem`,
  // 相关竞拍推荐
  getRecommendList: `${zzHost}/zzopen/zzbmmarketlogic/getRecommendInfoList`,
  // 获取质检报告
  getQcReport: `${zzHost}/zzopen/zzbmmarketlogic/getAuctionQcReport`,
  // 获取所有竞拍出价列表
  getAuctionOfferAll: `${zzHost}/zz/transfer/getAllPriceFront`,
  // 确认出价
  confirmOfferPrice: `${zzHost}/zz/transfer/offerPrice`,
  // 是否有竞拍权限
  hasAuctionAuth: `${zzHost}/zzopen/zzbmmarketlogic/checkUserAuth`,
  // 生成朋友圈海报
  getPosterImg: 'https://uapi.zhuanzhuan.com/v1.0/shots',
  // 生成二维码
  getMiniCode: `${zzHost}/zzopen/wxcommon/createCode2Long`,

  // 买家资质申请 ----- start ----
  // 查询权限申请状态
  getAuctionBuyerAuth: `${zzHost}/zzopen/zzbmmarketlogic/getAuthStatus`,
  // 申请权限
  checkValidAuth: `${zzHost}/zzopen/zzbmmarketlogic/checkValidAuth`,

  // 分类信息弹窗相关接口  ------- start ----
  // 获取支持批量下单的品类
  getBulkOrderEntryInfo: `${zzHost}/zzopen/zzbmlogic/getBulkOrderEntryInformation`,
  // 分类tab
  getCateTab: `${zzHost}/zzopen/zzbmlogic/getCateTabV2`,
  // 手机平板笔记本耳机
  getOldCateData: `${zzHost}/zzopen/zzbmlogic/getCateMaxBmPriceList`,
  // 智能数码tab 品类品牌机型
  getDigitalCateData: `${zzHost}/zzopen/zzbmlogic/getDigitalCateV2`,
  // 手机平板笔记本（优化后） getModelListWithPriceBySingleCate
  getCateModel: `${zzHost}/zzopen/zzbmlogic/getModelListWithPriceBySingleCate`,
  // 智能数码tab 品类品牌机型 (优化后) getModelListWithPriceByMultiCate
  getDigitalCateModel: `${zzHost}/zzopen/zzbmlogic/getModelListWithPriceByMultiCate`,
  // 智能数码tab 品类品牌机型 (优化后) getModelListWithPriceByPhotography
  getPhotographyCateModel: `${zzHost}/zzopen/zzbmlogic/getModelListWithPriceByPhotography`,
  // 更多tab下数据
  getMoreCateData: `${zzHost}/zzopen/zzbmlogic/getMoreCateV2`,
  // 全部tab下数据
  getAllCateList: `${zzHost}/zzopen/zzbmlogic/modelListAllCateList`,
  // 获取系列下机型
  getSeriesModelList: `${zzHost}/zzopen/zzbmlogic/getSeriesModelList`,
  // 搜索相关
  searchList: `${zzHost}/zzopen/zzbmlogic/getWordkeySearchResultNew`,
  // 获取热词推荐
  getHotWords: `${zzHost}/zzopen/zzbmlogic/getSearchRecommendList`,
  // 获取热门品类品牌
  getHotCateBrand: `${zzHost}/zzopen/zzbmlogic/getHotCateBrand`,
  // 搜索关键词品牌品类
  getKeyWordCate: `${zzHost}/zzopen/zzbmlogic/getKeyWordCate`,
  // 搜索历史
  getSearchHistoryData: `${zzHost}/zzopen/zzbmlogic/getSearchHistoryData`,
  // 删除历史
  delSearchData: `${zzHost}/zzopen/zzbmlogic/delSearchData`,
  // 记录用户选择的搜索结果
  saveSearchData: `${zzHost}/zzopen/zzbmlogic/saveSearchData`,

  // 新版机型选择页 ---> Start

  // 根据场景Id获取品类组
  getCategoryGroupList: `${zzHost}/zzopen/zzbmlogic/getCategoryGroupList`,

  // 根据场景Id和品类Id反查品类组
  getCategoryGroupBySceneIdAndCateId: `${zzHost}/zzopen/zzbmlogic/getCategoryGroupBySceneIdAndCateId`,

  // 根据品类组Id获取品类及品牌
  getCateWithBrandList: `${zzHost}/zzopen/zzbmlogic/getCateWithBrandList`,

  // 根据系列Id、品牌Id获取机型List
  getSeriesWithModelList: `${zzHost}/zzopen/zzbmlogic/getSeriesWithModelList`,

  // 估价新客挂件
  getEvalNewPendent: `${zzHost}/zzopen/zzbmlogic/getEvalNewPendent`,

  // 新版机型选择页 <--- End

  // 下单页相关接口 -------- start -----
  //用户选择加价券和精准估价的型号校验接口
  // 根据券id获取型号名称
  getModelNameDesc: `${zzHost}/zzopen/zzbmlogic/getModelNameDesc`,

  // 下单页-红包相关
  // 用户可用优惠券列表
  getCouponList: `${zzHost}/zzopen/zzbmlogic/displayRedPacket`,
  // 获取用户可用的优惠券列表信息
  getCouponBaseInfo: `${zzHost}/zzopen/zzbmlogic/getRedPacketReceiveInfo`,
  // 下单页-获取自行寄件的收件地址
  getDefaultWarehouse: `${zzHost}/zzopen/zzbmlogic/getDefaultWarehouse`,
  // 下单页-获取用户地址列表接口
  getAllAddress: `${zzHost}/zz/transfer/getAllAddress`,
  // 下单页-获取用户默认地址接口
  getDefaultAddress: `${zzHost}/zz/transfer/getDefaultAddress`,
  // 下单页-更新用户地址接口
  updateAddress: `${zzHost}/zz/transfer/updateAddress`,
  // 下单页-增加用户地址接口
  addAddress: `${zzHost}/zz/transfer/addAddress`,
  // 通用查询用户信息接口
  getUserInfoByUid: `${zzHost}/zzopen/zzbmlogic/getUserInfoByUid`,
  // 下单页-上门取件方式下单
  createOrderOfPickUp: `${zzHost}/zzopen/zzbmlogic/createOrderOfPickUp`,
  // 下单页-自行寄件方式下单
  createOrderOfSelfDelivery: `${zzHost}/zzopen/zzbmlogic/createOrderOfSelfDelivery`,
  // 方案D，获取累计帮助用户数，同C方案回收首页底部展示
  getHelpUsersInfo: `${zzHost}/zzopen/zzbmlogic/getSellCount`,
  // 交易快报列表
  getSaleHistoryList: `${zzHost}/zzopen/zzbmmarketlogic/getDealLetters`,
  // 获取精准估价参数-2020.11.18更新估价统一一个接口
  getEvaSkuParams: `${zzHost}/zzopen/zzbmlogic/getSkuParamsByBayes`,
  // 获取估价参数 携带modelName
  getSkuBayesParamPage: `${zzHost}/zzopen/zzbmlogic/getSkuBayesParamPage`,
  // 获取精准估价
  getPriceFromValuerBySku: `${zzHost}/zzopen/zzbmlogic/getPriceFromValuerBySku`,
  // 判断预质检码能否进入卖场（寄卖）
  getConsignQualification: `${zzHost}/zzopen/c2b_consignment/getSellingPreCheck`,
  // 缩略图弹窗接口
  getDescPopupInfo: `${zzHost}/zzopen/zzbmlogic/getWindowsByPic`,
  saveVirtualReport: `${zzHost}/zzopen/zzbmlogic/saveVirtualReport`,
  getVirtualReport: `${zzHost}/zzopen/zzbmlogic/getSelectVirtualReport`,

  // 获取evalPlanType
  getEvalPlanType: `${zzHost}/zzopen/zzbmlogic/getEvalPlanType`,
  // 优惠券列表
  getBMNewCouponList: `${zzHost}/zzopen/zzbmlogic/getBMNewCouponList`,
  // 去使用校验该优惠券是否过期
  checkCouponValidate: `${zzHost}/zzopen/zzbmlogic/checkCouponValidate`,
  // 发券 (下单页废弃)
  sendCoupon: `${zzHost}/zzopen/zzbmlogic/bmNewCoupon`,
  // 发券+弹窗 （新增）
  createOrderPagePopUp: `${zzHost}/zzopen/zzbmlogic/createOrderPagePopUp`,
  // 领劵
  receiveCoupon: `${zzHost}/zzopen/zzbmlogic/receiveBMNewCoupon`,
  // 估价页-B2C下回收单
  setEvaPriceInfo: `${zzHost}/zzopen/zzbmlogic/saveHighestAndCouponPriceToCache`,
  // 手机、平板品类下单时加价券是否符合规则校验
  checkCouponSku: `${zzHost}/zzopen/zzbmlogic/createOrderCheckCouponValidate`,
  // 以旧换新计算器-热销机型列表
  hotBrandModelList: `${zzHost}/zzopen/zzbmlogic/hotBrandModelList`,

  // 回收订单详情相关接口 -------- start --
  // 判断是新订单还是老订单
  isZZRecycleOrder: `${zzHost}/zzopen/zzbmlogic/getParentCateIdByCateId`,
  // 获取回收订单详情页信息
  getOrderDetail: `${zzHost}/zzopen/zzbmlogic/sellerOrderDetail`,
  // 获取新手机平板流程回收订单详情页
  getOrderDetailV2: `${zzHost}/zzopen/zzbmlogic/sellerOrderDetailV2`,
  // 我不卖了
  sellerDoNotSell: `${zzHost}/zzopen/zzbmlogic/sellerDoNotSell`,
  // 数码-不卖了退货
  sellerDoNotSellDigital: `${zzHost}/zzopen/zzbmlogic/sellerDoNotSellDigital`,
  // 参加竞拍
  joinAuction: `${zzHost}/zzopen/zzbmlogic/sellerJoinAuction`,
  // 重新竞拍
  againJoinAuction: `${zzHost}/zzopen/zzbmlogic/sellerAgainJoinAuction`,
  // 判断卖给回收商是否过期
  judgeDirectSellPrice: `${zzHost}/zzopen/zzbmlogic/judgeDirectSellPrice`,
  // 卖给回收商
  postDirectSell: `${zzHost}/zzopen/zzbmlogic/sellerDirectSelling`,
  // 卖给大b
  postDirectSellB: `${zzHost}/zzopen/zzbmlogic/sellerDirectSellingB`,
  // 卖给转转
  postDirectSellZZ: `${zzHost}/zzopen/zzbmlogic/sellerDirectSellingZZ`,
  // 订单页获取最新出价信息(竞拍详情页最新出价信息也在用这个接口)
  getLatestAuction: `${zzHost}/zz/transfer/getFrontPrice`,
  // 获取预约时间
  getReserveTimes: `${zzHost}/zzopen/zzbmlogic/getReserveTimes`,
  // 获取服务器当前时间戳
  getReserveTimesV2: `${zzHost}/zzopen/zzbmlogic/getReserveTimesV2`,
  // 顺丰预约
  bookingSfSave: `${zzHost}/zzopen/zzbmlogic/bookSf`,
  // 自行寄件
  selfDeliverySave: `${zzHost}/zzopen/zzbmlogic/delivery`,
  //退货、反馈原因获取接口
  getRefundReason: `${zzHost}/zzopen/zzbmlogic/suggestionTagList`,
  //退货、反馈枚举提交接口
  submitRefundReason: `${zzHost}/zzopen/zzbmlogic/feedback`,
  // 取消原因列表--邮寄
  cancelReasonList: `${zzHost}/zzopen/zzbmlogic/cancelReasonList`,
  // 是否命中上门回收--取消订单时引导用户去上门回收
  isHitZlj: `${zzHost}/zzopen/zzbmlogic/getDoorCreateOrderInfo`,
  // 快递公司列表接口
  getExpressList: `${zzHost}/zzopen/zzbmlogic/getExpressCompany`,
  // 吃货状态-点击再想想
  reAuction: `${zzHost}/zzopen/zzbmlogic/clickRePai`,
  // 订单详情页-质检中断-提交开机密码接口
  submitPwd: `${zzHost}/zzopen/zzbmlogic/writepassword`,
  // 订单详情页-质检中断-提交开机密码接口V2
  submitPwdV2: `${zzHost}/zzopen/zzbmlogic/writePasswordV2`,
  // 订单详情页-质检中断-根据中断类型查看填写记录
  queryPwdRecordByInterruptType: `${zzHost}/zzopen/zzbmlogic/queryPwdRecordByInterruptType`,
  // 订单详情页-质检中断-忘记开机密码 - 判断用户是否实人认证接口
  isRealUserCertification: `${zzHost}/zzopen/zzbmlogic/isRealUserCertification`,
  // 订单详情页-质检中断-忘记开机密码 - 用户即将实人认证关联订单号接口
  cacheUserCertificationRecycleOrderId: `${zzHost}/zzopen/zzbmlogic/cacheUserCertificationRecycleOrderId`,
  // 取消顺丰下单接口
  cancelOrder: `${zzHost}/zzopen/zzbmlogic/cancelSf`,
  // 取消订单加价券弹窗接口
  closeOrderCouponPopWindow: `${zzHost}/zzopen/zzbmlogic/closeOrderCouponPopWindow`,
  // 取消订单领取加价券接口
  closeOrderReceiveCoupon: `${zzHost}/zzopen/zzbmlogic/closeOrderReceiveCoupon`,
  // 获取用户取消订单时间距离预约取件时间是否在8小时内
  getCancelPopup: `${zzHost}/zzopen/zzbmlogic/getCancelPopup`,
  // 获取顺丰剩余上门时间
  getTime: `${zzHost}/zzopen/zzbmlogic/getTime`,
  // 订单详情页售出成功打款中打款重试
  recycleOrderDetailPayRetry: `${zzHost}/zzopen/zzbmlogic/recycleOrderDetailPayRetry`,
  // 取消退货申请
  cancelReturnApply: `${zzHost}/zzopen/zzbmlogic/cancelReturnApply`,
  // 根据订单号获取自行寄件地址
  getWarehouse: `${zzHost}/zzopen/zzbmlogic/getWarehouse`,
  // 物流信息接口
  getExpressInfo: `${zzHost}/zzopen/zzbmlogic/getExpressInfo`,
  // 订单详情页获取物流信息接口
  getRecycleOrderDeliveryInfo: `${zzHost}/zzopen/zzbmlogic/getRecycleOrderDeliveryInfo`,

  // 暗拍 ------------- start ------------
  // 暗拍出价记录
  getAnpaiAuctionRecord: `${zzHost}/zzopen/zzbmmarketlogic/getAnpaiPriceFront`,

  // 回收卖家、买家新订单列表页相关 -------------- start --------------
  sellerBMOrderList: `${zzHost}/zzopen/zzbmlogic/sellerOrderList`, // 卖家订单列表-回收
  sellerJMOrderList: `${zzHost}/zzopen/zzmarketbridge/consignmentOrderList`, // 卖家订单列表-寄卖
  buyerOrderList: `${zzHost}/zzopen/zzbmmarketlogic/getBuyerOrderList`, // 买家订单列表-回收&寄卖
  storeOrderList: `${zzHost}/zz/transfer/c2brecycleapi`, // 卖家订单列表-线下门店

  // 客服创建回收单 --------- start ---------
  customerCreateOrder: `${zzHost}/zzopen/zzbmlogic/customerCreateOrder`,
  // 客服页面信息
  getCustomerInitDataVo: `${zzHost}/zzopen/zzbmlogic/getCustomerInitDataVo`,
  // 获取用户地址列表
  getUserAddressList: `${zzHost}/zzopen/zzbmlogic/getUserZZAddressResultList`,
  // 保存新增地址
  saveAddress: `${zzHost}/zzopen/zzbmlogic/customerAddUserAddress`,
  // 查询顺丰预约地址
  sfOrderParams: `${zzHost}/zzopen/zzbmlogic/query`,
  // 修改预约顺丰
  updateSfOrderParams: `${zzHost}/zzopen/zzbmlogic/updateSf`,
  // 判断是否有客服加价
  hasKfAddPrice: `${zzHost}/zzopen/zzbmlogic/hasKfAddPrice`,

  // 数码 订单详情新增接口 ----- start ----
  // 获取相似机况出价列表
  getSimilarPriceList: `${zzHost}/zzopen/zzbmlogic/getSimilarProductPriceList`,
  // 数码盲拍-卖家确认出售商品
  sellerConfirmSale: `${zzHost}/zzopen/zzbmlogic/sellerConfirmSale`,
  // 数码直卖-卖家确认出售
  sellerConfirmDirectSale: `${zzHost}/zzopen/zzbmlogic/sellerConfirmDirectSale`,

  // 数码 竞拍详情页接口 ----- start -----
  // 盲拍预出价
  mpPreOfferPrice: `${zzHost}/zzopen/zzbmmarketlogic/mpPreOfferPrice`,

  // 买家订单转卖相关  --------- start -----------
  // 判断新老订单 （平台订单id for买家）
  getOrderOldOrNewByOrderId: `${zzHost}/zzopen/zzbmmarketlogic/getOrderOldOrNewByOrderId`,
  // 判断订单是否可以一键转卖
  canResellOrder: `${zzHost}/zzopen/zzbmmarketlogic/canResellOrder`,
  // 一键转卖确认
  buyerResell: `${zzHost}/zzopen/zzmarketbridge/createResaleOrder`,

  // 质检报告相关   --------- start -----------
  getReportNew: `${zzHost}/zzopen/zzbmmarketlogic/getSellerQcReport`,
  // 过程化报告阅读完成
  endReadingOfQcReport: `${zzHost}/zzopen/zzbmlogic/endReadingOfQcReport`,

  // 数码 卖场新增接口 --------- start ------------
  // 获取真实cateId
  queryRealCate: `${zzHost}/zzopen/zzbmmarketlogic/queryRealCate`,
  // 查询保证金余额
  mpDepositBalance: `${zzHost}/zzopen/zzbmmarketlogic/mpDepositBalance`,
  // 保证金充值
  mpDepositPaying: `${zzHost}/zzopen/zzbmmarketlogic/mpDepositPaying`,
  // 保证金能否提现
  mpDepositPreWithdraw: `${zzHost}/zzopen/zzbmmarketlogic/mpDepositPreWithdraw`,
  // 保证金提现
  mpDepositWithdrawApply: `${zzHost}/zzopen/zzbmmarketlogic/mpDepositWithdrawApply`,
  // 冻结保证金
  mpDepositFreeze: `${zzHost}/zzopen/zzbmmarketlogic/mpDepositFreeze`,
  // 同意协议
  mpAgreeProtocol: `${zzHost}/zzopen/zzbmmarketlogic/agreeProtocol`,
  // 盲拍出价
  mpOfferPrice: `${zzHost}/zzopen/zzbmmarketlogic/mpOfferPrice`,
  // 获取暗拍竞拍列表
  getMPFrontPrice: `${zzHost}/zzopen/zzbmmarketlogic/getMPFrontPrice`,

  // 新人领红包 ------------- start ---------
  // 提现
  withDrawMoney: `${zzHost}/zzopen/zzbmlogic/orderRedPacketWithdrawal`,
  // 首页新人弹窗
  getNewUserPopup: `${zzHost}/zzopen/zzbmlogic/newUserRedPopInfo`,

  // 下单页获取用户估价项列表
  getEvaluationItems: `${zzHost}/zzopen/zzbmlogic/getEvaluationItems`,

  // 订单新流程新增 ------------- start ---------
  // 质检中断获取类型以及图片
  getQcNeedPasswordPic: `${zzHost}/zzopen/zzbmlogic/getQcNeedPasswordPic`,
  // 查看已填写密码
  checkPassword: `${zzHost}/zzopen/zzbmlogic/checkPassword`,
  // 订单提交成功页
  orderSubmitSuccessInfo: `${zzHost}/zzopen/zzbmlogic/orderSubmitSuccessInfo`,
  // 订单评价页
  orderEvaluationPage: `${zzHost}/zzopen/zzbmlogic/orderEvaluationPageNew`,
  // 查看评价
  getEvaluationByOrderId: `${zzHost}/zzopen/zzbmlogic/getEvaluationByOrderId`,
  // 提交评价
  submitEvaluation: `${zzHost}/zzopen/zzbmlogic/submitEvaluationNew`,
  // 评价弹窗配置
  getAppraiseConfig: `${zzHost}/zzopen/zzbmlogic/getAppraiseConfig`,
  // 查看评价
  queryAppraiseByOrderId: `${zzHost}/zzopen/zzbmlogic/queryAppraiseByOrderId`,
  // 提交评价
  saveAppraise: `${zzHost}/zzopen/zzbmlogic/saveAppraise`,
  // 是否可以参与【分享获取现金券】活动
  getAllowJoinSwellCashCouponActivity: `${zzHost}/zzopen/zzbmlogic/getAllowJoinSwellCashCouponActivity`,
  // 参与【分享获取现金券】活动-发放金额券
  joinSwellCashCouponActivity: `${zzHost}/zzopen/zzbmlogic/joinSwellCashCouponActivity`,
  // 参与【分享获取现金券】活动-发放金额券的类型
  getSwellCashCouponSceneResult: `${zzHost}/zzopen/zzbmlogic/getSwellCashCouponSceneResult`,
  // 获取我的评估项
  myEvaluationItem: `${zzHost}/zzopen/zzbmlogic/myEvaluationItem`,
  // 竞拍说明页
  auctionDescription: `${zzHost}/zzopen/zzbmlogic/auctionDescription`,
  // 交易成功商品推荐
  recommendItems: `${zzHost}/zzopen/zzbmlogic/recommendItems`,
  // 一分钟了解回收 ------------- start ---------
  // 一分钟了解回收加价券区域接口
  oneMinuteBMGetCoupon: `${zzHost}/zzopen/zzbmlogic/oneMinuteBMGetCoupon`,
  // c2c闲置发布页到保卖，入口页面信息
  getModelInfoForBmEnterHalfPage: `${zzHost}/zzopen/zzbmlogic/getModelInfoForBmEnterHalfPage`,
  // c2c发布页新人首单半屏浮窗
  getCouponFloatInfo: `${zzHost}/zzopen/zzbmlogic/getCouponFloatInfo`,
  // c2c2bm 转卖 ------------- start ---------
  // c2c 转回收商品信息及收款信息
  c2c2bmConfirm: `${zzHost}/zzopen/zzbmlogic/c2c2bmConfirm`,
  // c2c 转回收 确认转卖
  c2c2bmSure: `${zzHost}/zzopen/zzbmlogic/c2c2bmSure`,
  // b2c 红包入口 ------------- start ---------
  // b2c 红包详情
  getRedPacketInfo: `${zzHost}/zzopen/zzbmlogic/getRedPacketInfo`,
  // b2c 领取红包
  getb2cRedPacket: `${zzHost}/zzopen/zzbmlogic/getb2cRedPacket`,
  // 排行榜
  listHomeRankListTabs: `${zzHost}/zzopen/zzbmlogic/listHomeRankListTabs`,
  getHomeSubTabDetail: `${zzHost}/zzopen/zzbmlogic/getHomeSubTabDetail`,
  getActivityPendant: `${zzHost}/zzopen/zzbmlogic/getActivityPendant`,
  submitComment: `${zzHost}/zzopen/zzbmlogic/saveUserHasAppraised`,
  // 帮助中心
  getQuestionAndAnsweringV3: `${zzHost}/zzopen/zzbmlogic/getQuestionAndAnsweringV3`,

  // 活动相关 ------------- start -------------
  //获取详情页活动红包信息
  aladdinOrderDetailPage: `${zzHost}/zzopen/zzbmlogic/aladdinOrderDetailPage`,
  //获取活动领取弹窗信息
  aladdinConfirmWindow: `${zzHost}/zzopen/zzbmlogic/aladdinConfirmWindow`,
  //领取奖品
  aladdinAcceptPrize: `${zzHost}/zzopen/zzbmlogic/aladdinAcceptPrize`,
  // 申请议价
  applyDirectSellBargainSubsidy: `${zzHost}/zzopen/zzbmlogic/applyDirectSellBargainSubsidy`,
  // 判断退回单邮寄类型是到付还是寄付
  getRecallExpressType: `${zzHost}/zzopen/zzbmlogic/getRecallExpressType`,
  // 隐私机提醒弹窗
  showPartCheckTipsWindow: `${zzHost}/zzopen/zzbmlogic/showPartCheckTipsWindow`,
  // 品类日活动详情接口
  getCateRecycleDayActivity: `${zzHost}/zzopen/zzbmlogic/getCateRecycleDayActivity`,

  // 上门回收 ------------ start --------------
  // 上门回收单详情
  getD2DSellerOrderDetail: `${zzHost}/zzopen/zzbmlogic/D2DSellerOrderDetail`,
  // 上门回收单夜间确单
  D2DNightConfirm: `${zzHost}/zzopen/zzbmlogic/D2DNightConfirm`,
  // 卖家确认出售
  confirmD2DSell: `${zzHost}/zzopen/zzbmlogic/D2DConfirmSell`,
  // 取消上门回收单
  cancelD2DOrder: `${zzHost}/zzopen/zzbmlogic/D2DCancelOrder`,
  // 确认取消页面信息
  cancelConfirmD2DDetail: `${zzHost}/zzopen/zzbmlogic/D2DCancelConfirmDetailNew`,
  // 查询预约信息
  sellerD2DReserveInfo: `${zzHost}/zzopen/zzbmlogic/D2DSellerReserveServiceInfo`,
  // 更改预约信息
  changeD2DReserveInfo: `${zzHost}/zzopen/zzbmlogic/D2DChangeReserveServiceInfo`,
  getVirtualRecentDealInfo: `${zzHost}/zzopen/zzbmlogic/getVirtualRecentDealInfo`,
  // 确认人脸核身完成
  D2DConfirmCertification: `${zzHost}/zzopen/zzbmlogic/D2DConfirmCertification`,
  judgeConfirmIntention: `${zzHost}/zzopen/zzbmlogic/judgeConfirmIntention`,

  // 新回收首页 ------------ start --------------
  // 获取机型卡片
  getUserModelCard: `${zzHost}/zzopen/zzbmlogic/getUserModelCard`,
  // 是否可以使用新用户评论
  userNewAppraise: `${zzHost}/zzopen/zzbmlogic/userNewAppraise`,
  // 新用户评论列表
  queryAppraisePage: `${zzHost}/zzopen/zzbmlogic/queryAppraisePage`,
  /**获取评价tab */
  getAppraiseTab: `${zzHost}/zzopen/zzbmlogic/getAppraiseTab`,
  getAppraiseTagCounterList: `${zzHost}/zzopen/zzbmlogic/getAppraiseTagCounterList`,
  /**获取新版评价列表 */
  getAppraise: `${zzHost}/zzopen/zzbmlogic/getAppraise`,
  // 新回收首页 ------------ end --------------

  // 二手可持续流转
  getOrderCirculation: `${zzHost}/zzopen/zzbmlogic/getOrderCirculation`,

  // 下单页地址模块重构
  // tabs选项
  getAddressTabs: `${zzHost}/zzopen/zzbmlogic/getAddressTabs`,
  // 回收车下单页tab
  getRecyclingCarAddressTab: `${zzHost}/zzopen/zzbmlogic/getRecyclingCarAddressTabV2`,
  // 预约时间: 门店+上门+邮寄 统一收拢
  getReserveTimesByType: `${zzHost}/zzopen/zzbmlogic/getReserveTimesByType`,
  // 获取用户手机号（门店下单回显）
  getUserPhoneByAddress: `${zzHost}/zzopen/zzbmlogic/getUserMobilePhone`,
  // 回收车聚合下单页
  getRecycleCarMultiOrderPage: `${zzHost}/zzopen/zzbmlogic/recycleCarMultiOrderCreateOrderPage`,
  // 获取商品支持履约范围
  getProductSupportDeliveryType: `${zzHost}/zzopen/zzbmlogic/getProductSupportDeliveryType`,
  // 检查履约方式
  checkUserSelectDeliveryType: `${zzHost}/zzopen/zzbmlogic/checkUserSelectDeliveryType`,
  // 更换履约方式
  saveUserSelectDeliveryType: `${zzHost}/zzopen/zzbmlogic/saveUserSelectDeliveryType`,

  // 兼容寄卖回收下单新接口
  createOrderOfConsign: `${zzHost}/zzopen/c2b_consignment/createOrder`,

  // 展示差异质检报告 或者老质检报告 类型 1老 2新
  getQcDiffReportType: `${zzHost}/zzopen/zzbmlogic/getQcDiffReportType`,

  // 点击催单按钮弹窗接口
  clickUrgeQc: `${zzHost}/zzopen/zzbmlogic/clickUrgeQc`,

  // 回收车下单接口
  batchCreateRecyclingCarOrder: `${zzHost}/zzopen/zzbmlogic/batchCreateRecyclingCarOrder`,
  queryBatchCreateResult: `${zzHost}/zzopen/zzbmlogic/queryBatchCreateResult`,
  // 回收车灰度接口
  recycleCarPreShunt: `${zzHost}/zzopen/zzbmlogic/recycleCarPreShunt`,
  // 全业务通用下单接口
  commonCreateOrder: `${zzHost}/zzopen/zzbmlogic/createOrder`,
  // 保存创建地址
  saveUserAddress: `${zzHost}/zzopen/zzbmlogic/saveUserAddress`,
  // 暗文手机号转成明文
  getUserRealPhone: `${zzHost}/zzopen/zzbmlogic/getUserRealPhone`,
  // 高德【个人中心】页面
  getMyCenterPage: `${zzHost}/zzopen/zzbmlogic/getMyCenterPage`,
  // 上门履约实验器灰度接口
  serviceTimeJudgeGrey: `${zzHost}/zzopen/zzbmlogic/serviceTimeJudgeGrey`,
  getQualityAuxiliaryEquipment: `${zzHost}/zzopen/zzbmlogic/getQualityAuxiliaryEquipmentV2`,
  // 发放特权卡礼包
  grantBenefitCard: `${zzHost}/zzopen/zzbmlogic/grantBenefitCard`,
  // 查询B2C购机用户权益
  judgeBenefitCard: `${zzHost}/zzopen/zzbmlogic/judgeBenefitCard`,
  // 新套机页面接口
  getComboSplitPage: `${zzHost}/zzopen/zzbmlogic/getComboSplitPageV2`,
  comboSaveRecyclingCarData: `${zzHost}/zzopen/zzbmlogic/comboSaveRecyclingCarData`,
  receiveDiagnosticCoupon: `${zzHost}/zzopen/zzbmlogic/receiveDiagnosticCoupon`,
  getMostEffectPriceItem: `${zzHost}/zzopen/zzbmlogic/getMostEffectPriceItem`,
  // 判断历史估价记录是否缺项需要重定向估价页，后端AB实验控制
  judgeEvaluationIsValid: `${zzHost}/zzopen/zzbmlogic/queryEvalItemIsNew`,
  // 下单页价格预期接口：
  getPriceExpectationList: `${zzHost}/zzopen/zzbmlogic/getPriceExpectationList`,
  // 半层弹出-查看券包信息
  queryGiftBagDetail: `${zzHost}/zzopen/zzbmlogic/queryGiftBagDetail`,
  // 领取卷包接口
  receiveGiftBag: `${zzHost}/zzopen/zzbmlogic/receiveGiftBag`,
  // 校验未成年人监护人
  checkGuardianOfMinor: `${zzHost}/zzopen/zzbmlogic/checkGuardianOfMinor`,
  // 获取优惠券列表
  getBmOrderCouponList: `${zzHost}/zzopen/zzbmlogic/getBmOrderCouponList`,

  // 黄金回收下单页：
  // 获取实时金价
  getRealTimeGoldPrice: `${zzHost}/zzopen/store_mobile_server/getRealTimeGoldPrice`,
  // 获取实时金价走势
  getRealTimeGoldPriceTrend: `${zzHost}/zzopen/store_mobile_server/getRealTimeGoldPriceTrend`,
  // 获取历史金价走势
  getHistoryGoldPriceTrend: `${zzHost}/zzopen/store_mobile_server/getHistoricalGoldPriceTrend`,
  // 获取门店详细
  getRecycleGoldStoreByLocation: `${zzHost}/zzopen/store_mobile_server/getRecycleGoldStoreByLocation`,
  // 获取系列
  getSeriesList: `${zzHost}/zzopen/luxuryrecycle/getSeriesList`,
  // 发送用户线索
  sendUserClue: `${zzHost}/zzopen/luxuryrecycle/sendUserClue`,
  // 获取私域信息
  getCrmInfo: `${zzHost}/zzopen/luxuryrecycle/getCrmInfo`,
  // 获取历史估价记录
  getUserEvalRecord: `${zzHost}/zzopen/luxuryrecycle/getUserEvalRecord`,
  //获取用户须知
  getUserNotice: `${zzHost}/zzopen/zzbmlogic/getUserNotice`,
  getUserNoticeV2: `${zzHost}/zzopen/zzbmlogic/getUserNoticeV2`,
  // 获取场景id
  getSceneId: `${zzHost}/zzopen/luxuryrecycle/getSceneId`,
  // 查询估价模板属性关联关系
  listAllValuePath: `${zzHost}/zzopen/zzbmlogic/listAllValuePathV2`,
  // 组装机 - 根据属性拉属性值
  getParamValueByCondition: `${zzHost}/zzopen/zzbmlogic/getParamValueByCondition`,
  // 组装机 - 根据属性获取筛选项
  getLabelGroupByParam: `${zzHost}/zzopen/zzbmlogic/getLabelGroupByParam`,
  // 组装机 - 查询可选组合路径（allPath）
  queryAllLabelPath: `${zzHost}/zzopen/zzbmlogic/queryAllLabelPath`,
  // 组装机 - 获取全量联想词
  getParamValueSynonyms: `${zzHost}/zzopen/zzbmlogic/getParamValueSynonyms`,
  // 获取搜索页面数据
  getSearchPageData: `${zzHost}//zzopen/zzbmlogic/getSearchHomePageConfig`,
  // 拍图识款
  getPhotoResult: `${zzHost}/api/luxurytodoor/userPhotoSearch`,
  // 获取加价券列表
  getEvalModelCouponPage: `${zzHost}/zzopen/zzbmlogic/getEvalModelCouponPage`,
  // 黄金订阅
  getGoldSubscriptionInfo: `${zzHost}/zzopen/store_mobile_server/getGoldSubscriptionInfo`,
  subscribePriceAlert: `${zzHost}/zzopen/store_mobile_server/subscribePriceAlert`,
  cancelPriceSubscription: `${zzHost}/zzopen/store_mobile_server/cancelPriceSubscription`,
  realTimeGoldPrice: `${zzHost}/api/store_market/readTimeGoldPrice`,
  // 机型列表 品牌系列机型是否走新页面，默认走弹窗
  getModelListNewPageGroupName: `${zzHost}/zzopen/zzbmlogic/getModelListNewPageGroupName`,
  // 价格行情
  aiPriceDetail: `${zzHost}/zzopen/zzbmlogic/aiPriceDetail`,
  // 搜索联想页
  searchAssociatePage: `${zzHost}//zzopen/zzbmlogic/searchAssociatePage`,
  // 获取免估价工程师首页信息
  getExemptEvalEngineerMainPage: `${zzHost}/zzopen/zzbmlogic/getExemptEvalEngineerMainPage`,
  // 推送免估价工程师信息
  pushExemptEvalEngineerInfo: `${zzHost}/zzopen/zzbmlogic/pushExemptEvalEngineerInfo`
}
